import { Alert, Box, Card, Link, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { formatResidentList } from '../utils';
import RequestStatusBadge from './RequestStatusBadge';

LocationDetail.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function LocationDetail({ label, value }) {
  if (!value) return null;

  return (
    <Typography component="div" sx={{ fontSize: '10px', color: 'text.secondary' }}>
      <Box component="span" sx={{ fontWeight: 600 }}>
        {label}:
      </Box>{' '}
      <Box component="span" sx={{ fontWeight: 400 }}>
        {value}
      </Box>
    </Typography>
  );
}

ResidentHeaderSection.propTypes = {
  residents: PropTypes.array,
  requestStatusId: PropTypes.number,
  facilityName: PropTypes.string,
  isRecurring: PropTypes.bool,
  isChildRequest: PropTypes.bool,
  parentRequestId: PropTypes.number,
  onOpenParentRequest: PropTypes.func,
  residentDetails: PropTypes.object,
};

export default function ResidentHeaderSection({
  residents,
  requestStatusId,
  facilityName,
  isRecurring,
  isChildRequest,
  parentRequestId,
  onOpenParentRequest,
  residentDetails,
}) {
  const showParentRecurringBanner = isRecurring === true && !isChildRequest;
  const showRecurringBanner = showParentRecurringBanner || isChildRequest;

  return (
    <Card sx={{ padding: 2, borderRadius: 1, mt: 1, mb: 2, width: '100%' }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" sx={{ gap: 1 }}>
        <Typography component="div" sx={{ textAlign: 'left' }}>
          <Box component="span" sx={{ fontSize: '14px', fontWeight: 600, color: 'text.secondary' }}>
            Resident Name:
          </Box>{' '}
          <Box component="span" sx={{ fontSize: '16px', fontWeight: 400 }} color="secondary.main">
            {formatResidentList(residents)}
          </Box>
        </Typography>

        <Box display="flex" alignItems="center" flexWrap="wrap" sx={{ gap: 1.5, ml: 2 }}>
          <LocationDetail label="Facility" value={facilityName} />
          <LocationDetail label="Unit" value={residentDetails?.unit} />
          <LocationDetail label="Room" value={residentDetails?.room} />
          <LocationDetail label="Bed" value={residentDetails?.bed} />
        </Box>
        <RequestStatusBadge requestStatusId={requestStatusId} />
      </Box>
      {showRecurringBanner && (
        <Alert
          icon={false}
          sx={{
            backgroundColor: '#F8F5FF',
            border: '1px solid #E9DDFE',
            mt: 2,
            py: 0.25,
            fontSize: '12px',
            lineHeight: '18px',
            color: '#475569',
            '& .MuiAlert-message': {
              width: '100%',
            },
          }}
        >
          {isChildRequest ? (
            <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.75 }}>
              <Box component="span">This event is part of a recurring series.</Box>
              {parentRequestId ? (
                <Link
                  component="button"
                  type="button"
                  onClick={onOpenParentRequest}
                  sx={{
                    color: '#64748B',
                    textDecoration: 'underline',
                    textUnderlineOffset: '2px',
                    fontWeight: 400,
                  }}
                >
                  View Original
                </Link>
              ) : null}
            </Box>
          ) : (
            'This request has recurring requests'
          )}
        </Alert>
      )}
    </Card>
  );
}
